// extracted by css-extract-rspack-plugin
export default {"blockedCards":"FMsbUrxSHkcS9PY_"};